import { privateApiClient } from './apiClient';

/**
 * Service pour gérer les caisses (cash registers)
 */

/**
 * Récupérer la caisse assignée à un caissier
 * @param {string} phoneNumber - Numéro de téléphone du caissier
 * @returns {Promise<Object|null>} Données de la caisse ou null
 */
export const fetchCashierRegister = async (phoneNumber) => {
    try {
        const { data } = await privateApiClient.get('/pos/cash-registers/by-cashier', {
            params: { cashier: phoneNumber }
        });
        
        return data || null;
    } catch (error) {
        if (error.status === 404) {
            return null; // Aucune caisse assignée
        }
        throw error;
    }
};

/**
 * Récupérer les détails d'un POS
 * @param {string} posId - ID du POS
 * @returns {Promise<Object>} Détails du POS
 */
export const fetchPosDetails = async (posId) => {
    const { data: response } = await privateApiClient.get(`/pos/${posId}`);
    return response.contents;
};

